import React from "react";
import {
  Container,
  Description,
  Heading,
  InnerTopContainer,
  MainContainer,
  BottomContainer,
  LeftContainer,
  RightContainer,
  ImageContainer,
  Button,
} from "./styled.components";
import CONSTRUCTIONIMG from "../../../../assets/images/construction.jpg";
import CTTIBUILDING from "../../../../assets/images/CTTI.jpeg";
import CBIBUILDING from "../../../../assets/images/CBI.jpeg";
import { useNavigate } from "react-router-dom";

const Gallery = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <MainContainer>
        <InnerTopContainer>
          <Heading>Gallery</Heading>
          <Description>
            HHH and Sons Presents a Proud Past And Will Keep The
            Promise For Days To Come
          </Description>
        </InnerTopContainer>
        <BottomContainer>
          <LeftContainer>
            <ImageContainer src={CONSTRUCTIONIMG} />
            <ImageContainer src={CTTIBUILDING} />
          </LeftContainer>
          <RightContainer>
            <ImageContainer src={CONSTRUCTIONIMG} />
            <ImageContainer src={CBIBUILDING} />
          </RightContainer>
        </BottomContainer>
        <Button onClick={() => navigate("/gallery")}>
          See More <span>&#8594;</span>
        </Button>
      </MainContainer>
    </Container>
  );
};

export default Gallery;
